import * as React from "react";
function SvgDailymotion(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M19 22.82a3.69 3.69 0 113.48-3.62A3.52 3.52 0 0119 22.82zM26.7 6l-4.4.91v6.5a5.05 5.05 0 00-4.21-1.89 7 7 0 00-5 2.06 7.57 7.57 0 00-2.4 5.6A7.57 7.57 0 0013.3 25a6.81 6.81 0 004.7 1.79A5.83 5.83 0 0022.41 25v1.7h4.29z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDailymotion);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
